import { CoreMenu } from '@core/types';

/** Menu projet Achat. */
export const menu: CoreMenu[] = [
  {
    id: 'dashboards',
    title: 'Dashboards',
    translate: 'Dashboards',
    type: 'item',
    icon: 'home',
    color: '#000000',
    url: 'dashboards',
  },
  {
    id: 'Achat',
    type: 'section',
    title: 'Achat',
    translate: 'Achat',
    icon: 'shopping-cart',
    children: [
      {
        id: 'achat-documents',
        title: 'Achat',
        translate: 'Achat',
        type: 'collapsible',
        icon: 'folder',
        expanded: true,
        children: [
          {
            id: 'commande-fournisseur',
            title: 'Commande fournisseur',
            translate: 'Commande fournisseur',
            type: 'item',
            icon: 'shopping-bag',
            url: 'achat/commande-fournisseur',
          },
          {
            id: 'bon-reception',
            title: 'Bon de réception',
            translate: 'Bon de réception',
            type: 'item',
            icon: 'package',
            url: 'achat/bon-reception',
          },
          {
            id: 'retour-fournisseur',
            title: 'Retour fournisseur',
            translate: 'Retour fournisseur',
            type: 'item',
            icon: 'rotate-ccw',
            url: 'achat/retour-fournisseur',
          },
          {
            id: 'facture-fournisseur',
            title: 'Facture fournisseur',
            translate: 'Facture fournisseur',
            type: 'item',
            icon: 'file',
            url: 'achat/facture-fournisseur',
          },
          {
            id: 'avoir-fournisseur',
            title: 'Avoir fournisseur',
            translate: 'Avoir fournisseur',
            type: 'item',
            icon: 'file-minus',
            url: 'achat/avoir-fournisseur',
          },
          {
            id: 'reassort',
            title: 'Réassort',
            translate: 'Réassort',
            type: 'item',
            icon: 'refresh-cw',
            url: 'achat/reassort',
          },
        ],
      },
    ],
  },
  {
    id: 'Fiche',
    type: 'section',
    title: 'Fiche',
    translate: 'Fiche',
    icon: 'rapports',
    children: [
      {
        id: 'clients-lib',
        title: 'Clients',
        translate: 'Clients',
        type: 'item',
        icon: 'users',
        url: 'bibliotheque-clients',
      },
      {
        id: 'fournisseurs',
        title: 'Fournisseurs',
        translate: 'Fournisseurs',
        type: 'item',
        icon: 'user',
        url: 'bibliotheque-fournisseurs',
      },
      {
        id: 'produits-services',
        title: 'Produits & Services',
        translate: 'Produits & Services',
        type: 'item',
        icon: 'box',
        url: 'bibliotheque-test',
      },
      {
        id: 'gestion-stock',
        title: 'Gestion stock',
        translate: 'Gestion stock',
        type: 'item',
        icon: 'layers',
        url: 'gestion-stock/actif',
      },
      {
        id: 'gamme',
        title: 'Gamme',
        translate: 'Gamme',
        type: 'item',
        icon: 'layers',
        url: 'gamme',
      },
    ],
  },
];
